import React, { useEffect, useState } from 'react';

import { Icon, Modal, ModalSize } from '@column/column-ui-kit';

import { NotificationList } from '~/components';
import { SetupDeviceMFA } from '~/lib/authn';
import { Inner } from '~/styles';

interface Props {
  onClose: () => void;
  onSuccess: () => void;
  open: boolean;
}

export const SetupMfaTotpModal: React.FC<Props> = ({ onClose, onSuccess, open }) => {
  // Once the code verifies, `SetupDeviceMFA` draws an animated check inline over the
  // code input (rather than swapping the whole modal for a success screen). We hold that
  // confirmation for a beat, then hand back to `onSuccess` so the modal animates away.
  const [succeeded, setSucceeded] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      setSucceeded(false);
    }
  }, [open]);

  useEffect(() => {
    if (!succeeded) {
      return undefined;
    }
    const timer = setTimeout(onSuccess, 1200);
    return () => clearTimeout(timer);
  }, [succeeded, onSuccess]);

  return (
    <Modal onClose={onClose} isOpen={open} size={ModalSize.Medium}>
      <Modal.IconCircle type="primary">
        <Icon.Key />
      </Modal.IconCircle>

      <Modal.Content>
        <Modal.Headline fullWidth align="center">
          Setup Authenticator App
        </Modal.Headline>

        <NotificationList display="popup" />

        <Inner p={0} pb={24}>
          <SetupDeviceMFA
            enabled={open}
            onSetupComplete={() => setSucceeded(true)}
            errorNotificationDisplay="popup"
            successNotificationDisplay="global"
          />
        </Inner>
      </Modal.Content>
    </Modal>
  );
};
